export default function Noise() {
    return <div className='absolute inset-0 noise-bg z-0' />;
}
